// В.2.b: Ошибка эксперимента (liv_oshibka_eksperimenta, common, 1/0/5).
// Триггер «когда его лечат»: каждый раз, когда эта карта получает реальное
// лечение (actualAmount > 0) → applyPermanentBuff +1/0/0 до конца боя.
//
// Если хил пришёл при actualAmount=0 (был на полном ХП) — событие healed
// НЕ эмитится из healUnit (см. heal.js), значит триггер тоже не сработает.
// Это намеренно по диздоку.
//
// Молчание блокирует триггер: runOnHealTriggers отбрасывает carriers с
// silenceSources / current.silenced.

import { registerOnHealTrigger } from './heal.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { applyPermanentBuff } from '../../buffs.js';

export const CARD_ID = 'liv_oshibka_eksperimenta';
const LABEL = 'Ошибка эксперимента';
const SOURCE_ID = 'liv_oshibka_eksperimenta_on_heal';

registerImplementedAbility(CARD_ID, 'trigger');

registerOnHealTrigger(CARD_ID, (state, healEvent) => {
  const card = healEvent?.target;
  if (!card) return;
  if (card.id !== CARD_ID) return;
  if (!card.isAlive || !card.isAlive()) return;
  applyPermanentBuff(state, card, { atk: 1, armor: 0, hp: 0 }, SOURCE_ID, LABEL);
});
